import React from "react";
import { ArrowRight, LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface CardActionItemProps {
  icon: LucideIcon;
  title: string;
  description: string;
  onClick: () => void;
  /** Dokumentnummer visas som liten grå chip, t.ex. "Dok 15" */
  docNumber?: string;
  /** Label shown next to the arrow, e.g. "Skapa" */
  actionLabel?: string;
  className?: string;
}

export const CardActionItem: React.FC<CardActionItemProps> = ({
  icon: Icon,
  title,
  description,
  onClick,
  docNumber,
  actionLabel = "Skapa",
  className
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "group relative h-full w-full text-left rounded-xl border border-border bg-card p-5",
        "flex flex-col shadow-sm transition-all duration-300 ease-out",
        "hover:shadow-lg hover:-translate-y-1 hover:border-primary/50",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        className
      )}
    >
      <span className="flex w-full items-start justify-between gap-2">
        <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary transition-colors duration-300">
          <Icon className="h-5 w-5" aria-hidden="true" />
        </span>
        {docNumber && (
          <span className="inline-flex items-center rounded-md bg-muted px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide text-muted-foreground">
            {docNumber}
          </span>
        )}
      </span>

      <span className="mt-4 block text-base font-semibold leading-snug text-foreground">
        {title}
      </span>

      <span className="mt-1.5 block text-sm leading-relaxed text-muted-foreground">
        {description}
      </span>

      <span className="mt-auto pt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary">
        {actionLabel}
        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
      </span>
    </button>
  );
};
